<template>
  <div id="swiperBodyList">
    <div id="bodyLits" v-for="item in data" :key="item.id" @click="open(item.id)">
      <img :src="item.titleImgUrl" style="width:99%;height:calc(100% - 30px);" alt="">
      <div id="name">{{item.name}}</div>
    </div>
    <!--<div style="text-align:center">-->
    <!--<el-pagination background layout="prev, pager, next" :total="total"></el-pagination>-->
    <!--</div>-->
  </div>
</template>
<script>
export default {
  props: ["data"],
  methods: {
    open(id) {
      this.$router.push({ name: "bodyS", query: { id: id } });
    }
  }
};
</script>
<style lang="less" type="text/css">
 #title_content img {
   display: none;
 }
</style>
<style lang="less" scoped>
#swiperBodyList {
  // margin-top: 30px;
  width: 1300px;
  margin: 30px auto;
  padding-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
}
#bodyLits {
  background: #f8f8f8;
  padding: 10px 10px;
  text-align: center;
  background: url(../assets/img/jpg19_03.jpg);
  background-size: 100% 100%;
  width: 330px;
  height: 230px;
  margin: 10px 35px;
  color: #575757;
  #name {
    font-size: 14px;
    font-weight: 600;
    height: 30px;
    line-height: 30px;
    text-align: center;
  }
  #title_content {
    font-size: 15px;
    padding: 2px;
    /deep/ :nth-of-type(n + 3) {
      display: none;
    }
    p :nth-of-type(n + 4){
      display: none;
    }
  }
  #data {
    font-size: 14px;
    margin-top: 10px;
  }
  #line {
    // background-image: url(../assets/img/bar8.png);
    height: 20px;
    margin: 10px auto;
    background-size: 100% 100%;
  }
}
</style>
